// src/pages/Home.jsx
import React from 'react';
import Avertissement from '../components/LandingPage-main/Avertissement';
import Hero from '../components/LandingPage-main/Hero';
import PainPoints from '../components/LandingPage-main/PainPoints';
import ExpertiseAffirmation from '../components/LandingPage-main/ExpertiseAffirmation';
import PricingMyPlum from '../components/LandingPage-main/PricingMyPlum';
import Comparison from '../components/LandingPage-main/Comparison';
import FAQ from '../components/LandingPage-main/FAQ';
import FinalCTA from '../components/LandingPage-main/FinalCTA';
import Status from '../components/LandingPage-main/Status';
import Navbar from '../components/LandingPage-main/Navbar';
import Footer from '../components/PlumPlusDash/Footer';

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Status />
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <Avertissement />
        <PainPoints />
        <ExpertiseAffirmation />
        <PricingMyPlum />
        <Comparison />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
